export const getSortDirection = (direction: string) => {
  if (direction === "ascend") return "asc";
  if (direction === "descend") return "desc";
  return "";
};
